import React, { useState, useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header"

// Three login roles. `userType` decides the Firestore collection used by AuthContext.
// Lawyer + Student both live in the "lawyers" collection (a student can later become a
// lawyer), so they only differ by `key` which is saved as the account role.
const ROLES = [
  { key: "lawyer", label: "Lawyer", userType: "lawyers" },
  { key: "student", label: "Law Student", userType: "lawyers" },
  { key: "client", label: "Client", userType: "Client" },
];

const Onboarding = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  // The highlight pill is sized/positioned to match the actual selected button,
  // so labels of different lengths (e.g. "Law Student") never overflow.
  const btnRefs = useRef([]);
  const [pillStyle, setPillStyle] = useState(null);

  useLayoutEffect(() => {
    if (selectedIndex === null) {
      setPillStyle(null);
      return;
    }
    const update = () => {
      const btn = btnRefs.current[selectedIndex];
      if (btn) setPillStyle({ left: btn.offsetLeft, width: btn.offsetWidth });
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [selectedIndex]);

  const handleRoleSelection = (index) => {
    const role = ROLES[index];
    setSelectedIndex(index);
    // userType -> collection (lawyers/Client); userRole -> sub-role used at sign-up
    localStorage.setItem("userType", role.userType);
    localStorage.setItem("userRole", role.key);
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 3000);
  };

  const selectedRole = selectedIndex !== null ? ROLES[selectedIndex] : null;
  const isClientSelected = selectedRole?.key === "client";

  const signInPath = !selectedRole
    ? "#"
    : isClientSelected
    ? "/portal/ClientSignIn"
    : "/portal/LawyerSignIn";
  const signUpPath = !selectedRole
    ? "#"
    : isClientSelected
    ? "/portal/ClientSignUp"
    : "/portal/LawyerSignUp";

  return (
    <>
    <Header />
        <div className="min-h-screen overflow-hidden py-10 sm:py-0  flex flex-col bg-[#060223] items-center justify-center relative">
        <img src="../ellipse-top.png" className='absolute rotate-27 right-[-25vw] top-[-20vh] sm:right-[-150px] sm:top-[-200px] ' alt="" />
        <img src="../ellipse-bottom.png" className='absolute sm:bottom-[-300px] bottom-[-20vh]' alt="" />
        <img src="../JURIDENT.png" className='absolute opacity-0 sm:opacity-[1] left-5' alt="" />
        <img src="../Jurident-Logo-bottom.png" className='absolute opacity-0 sm:opacity-[1] right-5 bottom-5' alt="" />

      {/* Pop-up Message */}
      {showPopup && selectedRole && (
        <div className="absolute top-20 bg-white text-black px-4 py-2 rounded-lg shadow-lg font-semibold">
          Selected as {selectedRole.label}
        </div>
      )}

      {/* Container for Image & Form (Centers content on large screens) */}
      <div className="sm:grid sm:grid-cols-3 items-center justify-center z-10">
        {/* Image Section */}
        <div className="flex flex-col items-center justify-center w-full">
          <img src='../LawyerImage.png' alt="Lawyer" className=" w-[150px]" />
        </div>

        {/* Form Section */}
        <div className="flex flex-col gap-5 text-center w-full col-span-2">
          <h1 className="text-[#C99F4A] text-5xl font-bold mb-3">Welcome to Jurident!</h1>
          <div className="flex flex-col gap-5 text-center w-full px-10">
            {/* Role selector — fully-rounded pill container with a sliding
                highlight that matches each option's width */}
            <div className="px-10 flex justify-center">
              <div className="relative inline-flex items-center p-1 rounded-full bg-gradient-to-b from-[#494360] to-[#3a3550] border border-[#cfc9e0]/55 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
                {/* Sliding highlight pill */}
                {pillStyle && (
                  <div
                    className="absolute top-1 bottom-1 rounded-full bg-gradient-to-b from-[#5a546f] to-[#4a4560] border border-[#ded9ec]/70 shadow-[0_2px_10px_rgba(0,0,0,0.35)] transition-all duration-300 ease-out"
                    style={{ left: pillStyle.left, width: pillStyle.width }}
                  />
                )}
                {ROLES.map((role, index) => (
                  <button
                    key={role.key}
                    ref={(el) => (btnRefs.current[index] = el)}
                    type="button"
                    onClick={() => handleRoleSelection(index)}
                    className={`relative z-10 py-1.5 px-5 sm:px-7 rounded-full text-sm sm:text-base font-bold tracking-wide whitespace-nowrap transition-colors duration-200 ${
                      selectedIndex === index
                        ? "text-white"
                        : "text-[#a8a4b8] hover:text-white"
                    }`}
                  >
                    {role.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col items-center px-10">
              <Link
                to={signInPath}
                className={`w-full py-4 text-center bg-blue-600 text-white rounded-xl mb-2 ${
                  selectedRole ? "" : "opacity-50 cursor-not-allowed pointer-events-none"
                }`}
              >
                Login
              </Link>
              <Link
                to={signUpPath}
                className={`w-full py-4 text-center bg-white text-black rounded-xl ${
                  selectedRole ? "" : "opacity-50 cursor-not-allowed pointer-events-none"
                }`}
              >
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Onboarding;
